import React from 'react';

import { DialogContent } from '~/@sochi-components/SochiDialog/DialogContent';
import { ProjectWeightReceiptInfo } from '~/@user-store/weightReceipts/projectWeightReceipts.store';
import { IProject } from '~/@views/UserView/ProjectPage/ProjectMassesDetails/types';
import { showCustomDialog } from '~/services/dialog';

import { DeliveryLineUpdateForm } from './DeliveryLineUpdateForm';

type DeliveryLineEditDialogProps = {
    project: IProject;
    deliveryLine: ProjectWeightReceiptInfo;
    onClose: (v: boolean) => void;
};

const DeliveryLineUpdateDialog = ({ project, deliveryLine, onClose }: DeliveryLineEditDialogProps) => {
    return (
        <DialogContent>
            <DeliveryLineUpdateForm onClose={onClose} deliveryLine={deliveryLine} project={project} />
        </DialogContent>
    );
};

export const showDeliveryLineUpdateDialog = (project: IProject, deliveryLine: ProjectWeightReceiptInfo) =>
    showCustomDialog({
        render: closeDialog => (
            <DeliveryLineUpdateDialog onClose={closeDialog} deliveryLine={deliveryLine} project={project} />
        ),
    });
